import script from "./TestimonialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialDialog.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialDialog.vue?vue&type=style&index=0&id=f67bc29c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f67bc29c"]])

export default __exports__